import { createContext, Dispatch, SetStateAction } from 'react'

// Categories configured in step 1 of the widget configurator
export type ConfiguredCategory = {
    id: number
    name: string
    color?: string
    therapistId?: number
    therapistName?: string
    isFromSubaccount?: boolean
}

// Therapists configured to offer appointments (main user + subusers)
export type ConfiguredTherapist = {
    id: number
    name: string
}

type BookingWidgetContextData = {
    therapistUUID: string
    requirePhoneNumber: boolean
    setRequirePhoneNumber: Dispatch<SetStateAction<boolean>>
    requireAddress: boolean
    setRequireAddress: Dispatch<SetStateAction<boolean>>
    requireBirthdate: boolean
    setRequireBirthdate: Dispatch<SetStateAction<boolean>>
    bookingNote: string | null
    setBookingNote: Dispatch<SetStateAction<string | null>>
    publicBookingSiteId?: string
    // Categories selected in step 1 - these define what's available in the widget
    configuredCategories?: ConfiguredCategory[]
    // Therapists for in-app configurator preview (not used on script-tag embeds)
    configuredTherapists?: ConfiguredTherapist[]
}

export const BookingWidgetContext = createContext<BookingWidgetContextData>({} as BookingWidgetContextData)
